import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import CreateSystemModal from '@modals/CreateSystemModal'

import PageContent from './components/PageContent'

const callbacks = (component: keyof typeof componentCallbacks, setState: Function) => {
  const componentCallbacks = {
    CreateSystemModal: {
      closeModal: () => setState({ showCreateSystemModal: false }),
      createSystem: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreateSystemModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreateSystemModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      showCreateSystemModal: () => setState({ showCreateSystemModal: true }),
      ...filterCallbacks,
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreateSystemModal
          // @ts-expect-error TS2322
          callbacks={callbacks('CreateSystemModal', setState)}
          showModal={showCreateSystemModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
